import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/homeMocks';

export default function DailyUpdateSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              每日更新
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2">
              最新章节日日更新，追更不等待
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="relative rounded-2xl overflow-hidden bg-primary-950 text-background-50 p-6 flex flex-col justify-between min-h-[340px] lg:min-h-[400px]">
            <div>
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/15 text-xs font-medium mb-4">
                今日精选
              </span>
              <img
                src={latestUpdates[0].coverImage}
                alt={latestUpdates[0].title}
                title={`${latestUpdates[0].title} - 韩漫大全每日更新`}
                className="w-full aspect-[3/2] object-cover rounded-xl mt-3"
              />
            </div>
            <div className="mt-4">
              <h3 className="font-heading text-lg font-bold">{latestUpdates[0].title}</h3>
              <p className="text-background-300 text-sm mt-1">{latestUpdates[0].latestChapter} · {latestUpdates[0].updatedAt}</p>
              <Link
                to={`/comic/${latestUpdates[0].id}`}
                className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 rounded-full bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {latestUpdates.slice(1, 5).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 p-5 flex flex-col cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="flex gap-4">
                <div className="w-24 h-32 shrink-0 rounded-xl overflow-hidden">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫大全`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-between flex-1 min-w-0">
                  <div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                        {comic.category}
                      </span>
                      <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                        {comic.status}
                      </span>
                    </div>
                    <h3 className="font-heading font-bold text-foreground-950 mt-2 text-base truncate">
                      {comic.title}
                    </h3>
                    <p className="text-foreground-600 text-xs mt-1">{comic.latestChapter}</p>
                  </div>
                  <p className="text-foreground-500 text-xs mt-2">{comic.updatedAt}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600"
          >
            查看全部更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}